export default __webpack_public_path__ + "static/media/Thought Gear Brainwash.3699bf9f.png";